import React, { useState } from "react";
import { EditableTextField } from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";
import { heightOptions } from "../../../../constant/Option";
import { toast } from "react-toastify";

const NonDisclouserAggrement = ({ MoveToPreviousTab, MoveToNextTab }) => {
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [accept,setAccept]=useState(false);
  const handleFileUpload = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));
    }
  };

  const handleNext=()=>{

    if(accept){
      toast.success("Action Successfull")
      MoveToNextTab()
    }else{
      toast.error("Please Accept the terms")
    } 

  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
      >
        Comapny Detail
      </Typography>

      <Grid
        container
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{
          height: "85%",
          display: "flex",
          justifyContent: "center",
          p: 0,
          m: 0,
        }}
      >
        <Grid
          item
          sx={{
            width: "60%",
            height: "100%",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            borderRadius: 2,
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <Box
            component="iframe"
            src={`https://docs.google.com/viewer?url=https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736221525/ovvqukzyb1kc1by0gjwz&embedded=true`}
            sx={{
              width: "100%",
              height: "100%",
              border: "none", // Removes the iframe border
              margin: 0,
              padding: 0,
              display: "block", // Ensures there are no inline gaps
            }}
          />
        </Grid>
      </Grid>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 1,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
                checked={accept}
                onChange={e=>setAccept(!accept)}
              sx={{
                color: "primary.main",
                "&.Mui-checked": {
                  color: "primary.main",
                },
              }}
            />
          }
          label="Accept & Continue"
        />
      </Grid>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
        }}
      >
        <CustomSecondaryButton
          label={"Back"}
          sx={{ margin: 2 }}
          onClick={MoveToPreviousTab}
        />
        <CustomSuccessButton
          label={"Accept & Continue"}
          onClick={handleNext}
        />
      </Grid>
    </Box>
  );
};

export default NonDisclouserAggrement;
